import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { InlineContent } from "../../../components/Shared";
import { Button, DatePicker, Input, Radio, Select, Table } from "antd";
import { feedColumns, filterFeedIsHiddenOptions, filterFeedSearchCategoryOptions, useGetAllFeedAdmin } from "./model";

const FeedManage = () => {
    const dateMap = {
        today: JSON.stringify([dayjs().startOf('d').format('YYYY-MM-DD'), dayjs().endOf('d').format('YYYY-MM-DD')]),
        week: JSON.stringify([dayjs().add(-7, 'd').startOf('d').format('YYYY-MM-DD'), dayjs().endOf('d').format('YYYY-MM-DD')]),
        month: JSON.stringify([dayjs().add(-30, 'd').startOf('d').format('YYYY-MM-DD'), dayjs().endOf('d').format('YYYY-MM-DD')]),
    }
    const [filterDateList, setFilterDateList] = useState<'all' | string[]>('all')
    const [filterFeedIsHiddenList, setFilterFeedIsHiddenList] = useState<['all' | 'true' | 'false' | 'null' | string]>(['all']);
    const [filterSearch, setFilterSearch] = useState<string>('')
    const [filterSearchCategory, setFilterSearchCategory] = useState<TFeedSearchCategory>('nickName');
    const [feedList, setFeedList] = useState<IFeedAdminResponse[]>([]);
    const responseQuery = 'id nickName content createdDate feedHiddenId isHidden totalClaimCnt feedCommentCnt';
    const { data, isSuccess, isFetching } = useGetAllFeedAdmin<IFeedAdminResponse[]>(responseQuery)

    const onFilterDataList = () => {
        if (!data) return;
        const fillterdData = data.filter(q =>
            (filterDateList === 'all' || (!dayjs(filterDateList[0]).startOf('d').isAfter(dayjs(q.createdDate)) && !dayjs(filterDateList[1]).endOf('d').isBefore(dayjs(q.createdDate)))) &&
            (filterFeedIsHiddenList.includes('all') || (filterFeedIsHiddenList.includes(String(q.isHidden)))) &&
            (filterSearchCategory === 'nickName'
                ? (q.nickName).includes(filterSearch)
                : filterSearchCategory === 'content'
                    ? (q.content).includes(filterSearch)
                    : filterSearchCategory === 'id'
                        ? (Number(q.id) === Number(filterSearch))
                        : true))
            .sort((a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate)))

        setFeedList(fillterdData)
    }

    useEffect(() => {
        if (!isSuccess) return
        onFilterDataList()
    }, [isSuccess, isFetching, filterDateList, filterFeedIsHiddenList, filterSearch, filterSearchCategory])

    return <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '32px' }}>
            <InlineContent title="처리 상태" content={<Select mode='multiple' value={filterFeedIsHiddenList} onChange={q => setFilterFeedIsHiddenList(q)} options={filterFeedIsHiddenOptions} style={{ width: '30%' }} />} />

            <InlineContent title="신고일시" content={<div>
                <div style={{ display: "flex", gap: "16px", flex: 3, }}>
                    <Radio.Group
                        optionType="button"
                        value={filterDateList === 'all' ? filterDateList : JSON.stringify(filterDateList)}
                        onChange={(q) => setFilterDateList(q.target.value === 'all' ? q.target.value : JSON.parse(q.target.value))}
                    >
                        <Radio value={'all'}>전체</Radio>
                        <Radio value={dateMap['today']}>오늘</Radio>
                        <Radio value={dateMap['week']}>7일</Radio>
                        <Radio value={dateMap['month']}>1개월</Radio>
                    </Radio.Group>
                    <DatePicker.RangePicker
                        allowClear={false}
                        value={filterDateList === 'all' ? undefined : [dayjs(filterDateList[0]), dayjs(filterDateList[1])]}
                        onChange={(dates) => setFilterDateList(dates && dates[0] && dates[1] ? [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')] : 'all')}
                    />
                </div>
            </div>} />

            <InlineContent title="검색" content={<div style={{ display: "flex", gap: "16px", flex: 3, }}>
                <Select defaultValue={filterSearchCategory} value={filterSearchCategory} onChange={q => setFilterSearchCategory(q)} options={filterFeedSearchCategoryOptions} />
                <Input value={filterSearch} onChange={(q) => setFilterSearch(q.target.value)} onPressEnter={onFilterDataList} style={{ width: '40%' }} />
                <Button type='primary' onClick={onFilterDataList}>검색</Button>
            </div>} />
        </div>

        <div style={{ fontWeight: 700, marginBottom: '16px' }}>
            검색 결과({feedList.length})
        </div>
        <Table dataSource={feedList} columns={feedColumns} rowKey={'id'} loading={isFetching} pagination={{ showSizeChanger: true }} />
    </>

}

export default FeedManage